exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comboBox .element {\n  padding-right: 16px;\n  padding-left: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/form/combo-box/combo-box.component.scss
// module id = ../../../../../src/app/components/form/combo-box/combo-box.component.scss
// module chunks = main